import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { provide, watch, ref, onBeforeMount, computed, onMounted } from 'vue';
import { useRoute } from "vue-router";
import { useHead } from '@vueuse/head';
import store from '@/store';
import TopNav from "@/components/top-nav";
import Sidebar from "@/components/sidebar";
import VideoDetail from "@/components/video-detail";
import SvgIcon from "@/components/modules/svg-icon";
import GoTop from "@/components/modules/go-top";
import { memberService, languageService } from "@/utils";
import Login from './components/login.vue';
import { UtilityService } from "@/utils";
import { routeLayoutEnum } from "@/enums/router";
export default {
  components: {
    TopNav,
    Sidebar,
    SvgIcon,
    VideoDetail,
    GoTop,
    Login
  },
  setup() {
    provide('store', store);
    const route = useRoute();
    const isShowDetail = ref(false);
    const {
      getLocaleMessege,
      getCountryCode,
      getLanguage
    } = languageService;
    const {
      videoType
    } = UtilityService;
    const isNotAuth = computed(() => store.member.states.isNotAuth);
    const isEmbedLayout = computed(() => route.meta?.layout === routeLayoutEnum.EMBED);
    const meta = computed(() => {
      const metaTable = {
        "/home/iclone": getLocaleMessege("HOME_EXPLORER").META.ICLONE,
        "/home/character-creator": getLocaleMessege("HOME_EXPLORER").META.CHARACTER_CREATOR,
        "/home/cartoon-animator": getLocaleMessege("HOME_EXPLORER").META.CARTOON_ANIMATOR,
        "/home/actorcore": getLocaleMessege("HOME_EXPLORER").META.ACTORCORE,
        "/home/smart-gallery": getLocaleMessege("HOME_EXPLORER").META.SMART_GALLERY,
        "/home/workgroup": getLocaleMessege("HOME_EXPLORER").META.WORKGROUP,
        "/home/accurig": getLocaleMessege("HOME_EXPLORER").ACCURIG,
        "/history": getLocaleMessege("HISTORY").META,
        "/library": getLocaleMessege("LIBRARY").META,
        "/master-class": getLocaleMessege("PAGE_MASTER_CLASS").META,
        "/whats-new": getLocaleMessege("WHATS_NEW").META,
        "/pipeline": getLocaleMessege("PIPELINE").META,
        "/webinar": getLocaleMessege("WEBINAR").META,
        "/online-manual": getLocaleMessege("ONLINE_MANUAL").META,
        "/bookmark": getLocaleMessege("BOOKMARK").META,
        "/ap-embed/hub": {
          TITLE: "Reallusion Courses",
          DESCRIPTION: "",
          OG_TITLE: "",
          OG_DESCRIPTION: ""
        },
        "/": getLocaleMessege("HOME").META
      };
      const [path, meta] = Object.entries(metaTable).find(([key, _]) => {
        const regex = new RegExp(`^${key}`);
        return regex.test(route.path);
      }) ?? ["/", {}];
      return {
        ...meta,
        path
      };
    });
    const currentLang = computed(() => getLanguage());
    if (!isEmbedLayout.value) {
      memberService.loadLoginInfo();
    }
    useHead({
      title: computed(() => meta.value.TITLE),
      meta: [{
        name: "description",
        content: computed(() => meta.value.DESCRIPTION)
      }, {
        name: "language",
        content: computed(() => getCountryCode())
      }, {
        property: "og:title",
        content: computed(() => meta.value.OG_TITLE)
      }, {
        property: "og:description",
        content: computed(() => meta.value.OG_DESCRIPTION)
      }, {
        property: "og:url",
        content: process.env.VUE_APP_WEBSITE_URL + computed(() => meta.value.path)
      }]
    });
    const checkDetailDisplayByRoute = () => {
      const routeNameExcludeLang = route.path.toLocaleLowerCase().replace(new RegExp(currentLang.value + "/"), "").split("/").slice(1);
      isShowDetail.value = route.query.v !== undefined && routeNameExcludeLang[0] !== videoType.skillPath.category;
    };
    const initRlBanner = () => {
      if (isEmbedLayout.value) {
        return;
      }
      if (window.rlBannerController) {
        window.rlBannerController.init();
      }
    };
    watch(() => route.query, () => {
      checkDetailDisplayByRoute();
    });
    onBeforeMount(() => {
      checkDetailDisplayByRoute();
    });
    onMounted(() => {
      initRlBanner();
    });
    return {
      isNotAuth,
      isShowDetail,
      isEmbedLayout
    };
  }
};